<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="regulFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="regulFlag"
            label="규제물질 대상여부"
            v-model="searchParam.regulFlag"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-select
            type="search"
            codeGroupCd="REGULATION_BILL_API_CD"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="regulationBillCds"
            v-model="searchParam.regulationBillCds"
            @datachange="billCdChange"
          >
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-multi-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCd"
            label="규제 법규"
            name="regulatedItemCds"
            v-model="searchParam.regulatedItemCds"
          >
          </c-multi-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="화학물질 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="화학물질 관리대장 엑셀 파일 업로드"
            icon="note_add"
            @btnClicked="openExcelUploader"
          />
          <c-btn
            v-if="editable"
            label="LBLREG"
            icon="add"
            @btnClicked="linkClick"
          />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "chemBase",
  data() {
    return {
      searchParam: {
        regulFlag: null,
        regulationBillCds: [],
        regulatedItemCds: [],
        deleteFlag: 'N'
      },
      grid: {
        columns: [
          {
            name: "chem",
            field: "chem",
            label: "화학물질명",
            child: [
              {
                name: "chemNmEn",
                field: "chemNmEn",
                label: "영문",
                align: "left",
                sortable: true,
                style: "width: 120px",
                type: "link",
              },
              {
                name: "chemNmKr",
                field: "chemNmKr",
                label: "국문",
                align: "left",
                sortable: true,
                style: "width: 120px",
              },
            ],
          },
          {
            name: "casNo",
            field: "casNo",
            label: "CAS No.",
            align: "center",
            sortable: true,
            style: "width: 80px",
            // type: "link",
          },
          {
            name: "molecularFormula",
            field: "molecularFormula",
            label: "화학식",
            align: "center",
            sortable: true,
            style: "width: 100px",
          },
          {
            name: "regulFlag",
            field: "regulFlag",
            label: "규제물질<br/>대상여부",
            style: "width:90px",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      regulFlagItems: [
        { code: "Y", codeName: "규제O" },
        { code: "N", codeName: "규제X" },
      ],
      searchLawItems: [],
      searchLaw: [],
      regulatedItems: [],
      originalData: [],
      filterData: [],
      editable: true,
      listUrl: "",
      regsUrl: "",
      saveUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.base.chemBase.list.url;
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;
      this.saveUrl = transactionConfig.chm.base.chemBase.saves.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    billCdChange() {
      this.$http.url = this.regsUrl;
      this.$http.type = "GET";
      this.$http.param = {
        searchItems: this.searchParam.regulationBillCds,
      };
      this.$http.request((_result) => {
        this.regulatedItems = _result.data;
      });
    },
    linkClick(row) {
      this.popupOptions.title = "화학물질 상세";
      this.popupOptions.param = {
        mdmChemId: row ? row.mdmChemId : "",
      };
      this.popupOptions.target = () => import(`${"./chemBaseDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    openExcelUploader() {
      this.popupOptions.title = "배출량 통계조사대상 화학물질 엑셀 업로드";
      this.popupOptions.param = this.popupParam;
      this.popupOptions.target = () =>
        import(
          `${"@/pages/mdm/mam/chem/chemEmissionsSurveyTargetExcelUpload.vue"}`
        );
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeExcelUploaderPopup;
    },
    closeExcelUploaderPopup(_result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (_result && _result.length > 0) {
        let s_data = this.$_.filter(_result, (item) => {
          return !item.error_message;
        });
        this.$_.forEach(s_data, (item) => {
          item.deleteFlag = "N";
          item.regUserId = this.$store.getters.user.userId;
          item.editFlag = "C";
          item.reguls = [
            {
              mdmChemId: "", // 화학물질 일련번호
              regulatedItemCd:
                item.prtr === "PRTR1그룹" ? "D10010007" : "D10010008", // 규제항목 코드
              regulatedReason: "", // 규제대상 사유
              notiNo: "", // 고시번호
              notice: "", // 고시내용
              notiDt: "", // 고시일자
              uniqNo: "", // 고유번호
              appliStandContents: "", // 적용기준 내용
              appliStandSign: ">", // 적용기준 부등호
              appliStandQuantity: item.appliStandQuantity, // 적용기준 정량값
              appliStandUnit: "%", // 적용기준 단위
              editFlag: "C",
            },
          ];
        });

        this.$http.url = this.saveUrl;
        this.$http.type = "POST";
        this.$http.param = s_data;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getList();
        });
      }
    },
  },
};
</script>
